<template>
  <svg :width="width" :height="height" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 9.45703C6.3236 9.45703 6.58594 9.1947 6.58594 8.87109C6.58594 8.54749 6.3236 8.28516 6 8.28516C5.6764 8.28516 5.41406 8.54749 5.41406 8.87109C5.41406 9.1947 5.6764 9.45703 6 9.45703Z"
      :fill="color"
    />
    <path
      d="M6 0C2.68397 0 0 2.68352 0 6C0 9.31603 2.68352 12 6 12C9.31603 12 12 9.31648 12 6C12 2.68397 9.31648 0 6 0ZM6 11.0625C3.2021 11.0625 0.9375 8.79827 0.9375 6C0.9375 3.2021 3.20173 0.9375 6 0.9375C8.7979 0.9375 11.0625 3.20173 11.0625 6C11.0625 8.7979 8.79827 11.0625 6 11.0625Z"
      :fill="color"
    />
    <path
      d="M5.53125 7.03125V6.29293V4.64062V3.46875C5.53125 3.20986 5.74111 3 6 3C6.25889 3 6.46875 3.20986 6.46875 3.46875V4.64062V6.29293V7.03125C6.46875 7.29014 6.25889 7.5 6 7.5C5.74111 7.5 5.53125 7.29014 5.53125 7.03125Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
